<template>
  <v-container fluid class="pa-4">
    <v-row class="mb-6">
      <v-col cols="12">
        <h1 class="text-h4 font-weight-bold primary--text">
          {{ $t('course_agreements_list') }}
        </h1>
        <p class="text-subtitle2 grey--text mt-2">
          {{ $t('course_agreements') }}
        </p>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col cols="12" md="6">
        <v-select
          v-model="filterType"
          :label="$t('agreement_type')"
          :items="agreementTypeOptions"
          item-text="text"
          item-value="value"
          outlined
          dense
          clearable
          @input="applyFilter"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="onlyActive"
          :label="$t('only_active')"
          @change="applyFilter"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

    <div v-else-if="filteredAgreements.length === 0" class="text-center py-12">
      <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-information-outline</v-icon>
      <p class="text-h6 grey--text">{{ $t('no_agreements') }}</p>
    </div>

    <v-row v-else>
      <v-col
        v-for="agreement in filteredAgreements"
        :key="agreement.id"
        cols="12"
        sm="6"
        md="4"
      >
        <CourseAgreementCard
          :agreement="agreement"
          @contact="contactCoordinator"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseAgreementCard from './components/CourseAgreementCard.vue'

export default {
  name: 'CourseAgreementsList',
  components: {
    CourseAgreementCard
  },
  data () {
    return {
      filterType: null,
      onlyActive: true,
      agreementTypeOptions: [
        { text: this.$t('agreement_type_pago'), value: 1 },
        { text: this.$t('agreement_type_cortesia'), value: 2 },
        { text: this.$t('agreement_type_intercambio'), value: 3 },
        { text: this.$t('agreement_type_privilegio'), value: 4 },
        { text: this.$t('agreement_type_especial'), value: 5 }
      ]
    }
  },
  computed: {
    ...mapState('courseAgreements', {
      agreements: 'agreements',
      loading: 'loading'
    }),
    filteredAgreements () {
      let filtered = this.agreements

      if (this.onlyActive) {
        filtered = filtered.filter(a => a.is_active)
      }

      if (this.filterType !== null) {
        filtered = filtered.filter(a => a.agreement_type === this.filterType)
      }

      return filtered
    }
  },
  mounted () {
    this.loadAgreements()
  },
  methods: {
    ...mapActions('courseAgreements', ['fetchAll']),
    async loadAgreements () {
      await this.fetchAll()
    },
    applyFilter () {
      // Filtrado hecho en computed property
    },
    contactCoordinator (email) {
      window.location.href = `mailto:${email}`
    }
  }
}
</script>

<style scoped lang="scss">
</style>
